import * as React from 'react'
import styled from 'styled-components'
import ZingCertified from '../../../assets/img/zing-certified.png'
import MasterCard from '../../../assets/img/card-linking/mastercard.png'
import Visa from '../../../assets/img/card-linking/visacard.png'
import GCash from '../../../assets/img/gcash/gcash-logo.png'

import sanitizeHTML from '../../../services/sanitizeHTML'
import { setGAEvent } from '../../../services/analytics/google-analytics'

import media from '../../../services/generateMediaQueries'

import viewTypeBaseUrl from '../../../services/data/viewTypeBaseUrl'

import SideModal from '../../ui/SideModal/SideModal'
import Icon from '../../ui/Icon/Icon'
import ArticleCard from '../../ui/ArticleCard/ArticleCard'
import IndoorMap from '../IndoorMap/IndoorMap'
import ResponsiveAdsContainer from '../../ads/ResponsiveAdsContainer/ResponsiveAdsContainer'
import DesktopLeaderboard from '../../ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../ads/MobileRectangle/MobileRectangle'
import FeatureMaintenanceModal from '../../../components/home/FeatureMaintenanceModal/FeatureMaintenanceModal'
// import InnerPageLeaderboard from '../../ads/InnerPageLeaderboard/InnerPageLeaderboard'
// import InnerPageRectangle from '../../ads/InnerPageRectangle/InnerPageRectangle'
import ExternalRedirectModal from '../../../components/home/ExternalRedirectModal/ExternalRedirectModal'
import useFeatureMaintenance, {
  FEATURES_LIST,
} from '../../../services/hooks/useFeatureMaintenance'

const ContentContainer = styled.div`
  position: relative;
  margin: 0 3.625rem;
  margin-top: -190px;
  margin-bottom: 3.625rem;
  background: #ffffff;
  padding: 4rem 3.125rem;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-medium);

  ${media.lessThan('small')`
    margin: 0;
    padding: 3.25rem 2.75rem;
    border-radius: 0;
  `}
`

const Container = styled.div`
  flex: 1;
  background: var(--color-bg-light);
`

const MerchantLogo = styled.img`
  float: left;
  max-height: 80px;
  max-width: 80px;
  margin-right: 1.25rem;
  margin-bottom: 1.25rem;
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.375rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.9375rem;
  margin: 0;

  ${media.lessThan('small')`
    font-size: 1.2rem;
  `}
`

const Body = styled.div`
  line-height: 1.75rem;
  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  > figure {
    margin: 0;

    > img {
      max-width: 100%;
    }

    > table {
      width: 100%;
      margin: 0 -0.5rem;
      border-collapse: collapse;
      td,
      th {
        padding: 0 0.5rem;
        border: 1px solid #ccc;
      }
    }
  }

  margin-bottom: 4rem;
`

const RelatedContainer = styled.div`
  padding: 3.625rem;
  padding-top: 0;

  ${media.lessThan('small')`
    padding: 2rem 1.25rem;
  `}
`

const RelatedTitle = styled.h2`
  color: var(--color-primary);
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  margin: 0;
  margin-bottom: 2rem;

  ${media.lessThan('medium')`
    font-size: 0.875rem;
  `};
`

const StyledBanner = styled.div`
  width: 100%;
  min-height: 451px;
  background-image: ${({ background }) => `url('${background}')`};
  background-size: cover;
  background-position: center;

  ${media.lessThan('small')`
  min-height: 202px;
  `}
`

const StoreLinksContainer = styled.div`
  padding-top: 3rem;
`

const StoreLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  border-top: 1px solid var(--color-fg-lighter);
  padding: 0.8rem 0;
  justify-content: flex-start;

  > p {
    line-height: 1.75rem;
    margin: 0;
    padding: 0 1rem;
    flex: 1;
  }
`

const DescriptionItem = styled.p`
  flex: 1 1 auto;
  word-wrap: break-word;
  min-width: 0;
`

const StoreLinkDescription = styled.p`
  flex: 1 1 auto;
  font-size: 0.9375rem;
  font-weight: var(--font-weight);
  display: inline-flex;
  flex-direction: column;
  min-width: 0;

  > p {
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    margin-bottom: 0.5rem;
    word-wrap: break-word;

    &:last-child {
      margin: 0;
    }
  }
`

const IconContainer = styled.div`
  display: flex;
  color: var(--color-primary);
  font-size: 1rem;
  margin-top: 0.3rem;
`

const StyledLink = styled.a`
  flex: 0 0 auto;
  font-size: 0.75rem;
  font-weight: var(--font-weight-boldest);
  text-decoration: none;
  cursor: pointer;
  margin-top: 0.3rem;
  text-transform: uppercase;
`

const StyledIndoorMap = styled(IndoorMap)`
  position: relative;
  width: 100% !important;
  padding: 0 !important;
  border: 1px solid var(--color-fg-lighter);
  margin-top: 3rem;
  height: 230px;
`

const StyledBadge = styled.img`
  // filter: saturate(33) brightness(0.95);
  line-height: 0;
  margin-bottom: -1rem;
  margin-top: -1.25rem;
  // border-radius: 50%;
  width: 1.5rem;
  vertical-align: middle;
  // margin-left: 0.5rem;
  margin-right: 0.5rem;
`

const EngagementHighlight = styled.div`
  margin-top: 3rem;
  background-color: var(--color-primary);
  color: var(--color-bg-form);
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

const ShopPhoto = styled.div`
  width: 64px;
  height: 64px;

  img {
    object-fit: cover;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    width: 100%;
    height: 100%;
  }
`

const ShopLink = styled.div`
  box-sizing: border-box;
  width: calc(100% - 64px - 30px - 2rem);
  padding: 10px 0 10px 0;
`

const ShopArrow = styled.div`
  width: 30px;
`

const ShopActionLabel = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.8rem;
`

const ShopActionLink = styled.div`
  font-size: 0.8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

const CallIcon = styled.div`
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CallActionLabel = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.8rem;
  width: 50%;
  text-align: right;
  margin-right: 1rem;
  color: #fff !important;
  text-decoration: none;
`

const CallNumber = styled.div`
  width: calc(100% - 40px - 1rem - 120px);
`

const BadgeContainer = styled.div`
  display: inline;
  margin: 1rem;
  ${media.lessThan('small')`
    display: block;
    margin: 0;
    `}
`

const merchantDetailEvent = {
  socialMedia: 0,
  contact: 1,
  map: 2,
}

const StoreModal = ({ show, onClose, loading, data }) => {
  const {
    floor,
    mall,
    contactNumbers,
    operatingHours,
    merchant,
    zingPartner,
    operationStatus,
    engagement,
    externalId,
    onlineOrderingUrl,
    acceptsCreditCard,
    acceptsGCash,
  } = data || {}
  const {
    relatedArticles = [],
    name: title,
    description: body,
    bannerUrl: bannerImageUrl,
    logoUrl,
    websiteUrl,
    socialMediaLinks,
    // paymentMode = ['creditcard', 'gcash'], //temporary
  } = merchant || {}
  const { slugName, name: mallName, location } = mall || {}
  const [
    displayExternalRedirectModal,
    setDisplayExternalRedirectModal,
  ] = React.useState(false)

  const [showMaintenanceModal, setShowMaintenanceModal] = React.useState(false)

  const toggleMaintenanceModal = () => {
    setShowMaintenanceModal(!showMaintenanceModal)
  }

  const { isFeatureAvailable } = useFeatureMaintenance({
    feature: FEATURES_LIST.INDOOR_MAPS,
  })

  // const [adType, setAdType] = React.useState(false)

  // React.useEffect(() => {
  //   setAdType(Boolean(Math.random() >= 0.5))
  // }, [])
  // const setExternalRedirectModalVisible = b => e => {
  //   if (e) {
  //     e.preventDefault()
  //   }
  //   setDisplayExternalRedirectModal(b)
  //   // this.setState({
  //   //   displayExternalRedirectModal: b,
  //   // })
  // }

  const onRedirectAnalytics = ({ eventType, data }) => {
    const { socialMedia, contact, map } = merchantDetailEvent
    switch (eventType) {
      case socialMedia: {
        setGAEvent(
          'view_merchant_social_media_link',
          'item_name',
          data.itemName,
        )
        setGAEvent(
          'view_merchant_social_media_link',
          'mall_name',
          data.mallName,
        )
        setGAEvent('view_merchant_social_media_link', 'value', data.value)
        break
      }
      case contact: {
        setGAEvent(
          'view_merchant_econcierge_contact',
          'item_name',
          data.itemName,
        )
        setGAEvent(
          'view_merchant_econcierge_contact',
          'mall_name',
          data.mallName,
        )
        setGAEvent('view_merchant_econcierge_contact', 'value', data.value)
        break
      }
      case map:
      default: {
        setGAEvent('view_merchant_map', 'item_name', data.itemName)
        setGAEvent('view_merchant_map', 'mall_name', data.mallName)
      }
    }
  }

  return (
    <SideModal
      show={show}
      onClose={e => {
        e.stopPropagation()
        onClose()
      }}
      loading={loading}
    >
      <StyledBanner background={bannerImageUrl} />
      <Container>
        <ContentContainer>
          <MerchantLogo src={logoUrl} />
          <Title>
            {title}
            <BadgeContainer>
              {zingPartner && (
                <StyledBadge src={ZingCertified} alt="zing-certified" />
              )}
              {acceptsCreditCard && (
                <>
                  <StyledBadge src={MasterCard} alt="mastercard" />
                  <StyledBadge src={Visa} alt="visa" />
                </>
              )}
              {acceptsGCash && <StyledBadge src={GCash} alt="gcash" />}
            </BadgeContainer>
          </Title>
          <Body dangerouslySetInnerHTML={{ __html: sanitizeHTML(body) }} />
          {show && !!slugName && (
            <StyledIndoorMap
              mall={slugName}
              merchantName={title}
              floor={floor}
              externalId={externalId}
              onRedirect={() =>
                isFeatureAvailable()
                  ? onRedirectAnalytics({
                      eventType: merchantDetailEvent.map,
                      data: {
                        itemName: title,
                        mallName,
                      },
                    })
                  : setShowMaintenanceModal(true)
              }
              isFeatureAvailable={isFeatureAvailable()}
              preview
            />
          )}
          {engagement && engagement.actionType !== null && (
            <>
              {engagement.actionType === 0 && (
                <EngagementHighlight
                  onClick={() => {
                    setDisplayExternalRedirectModal(true)
                  }}
                >
                  <ShopPhoto>
                    <img src={bannerImageUrl} alt="Banner" />
                  </ShopPhoto>
                  <ShopLink>
                    <ShopActionLabel>
                      {engagement.actionLabel
                        ? engagement.actionLabel
                        : 'Shop Online Now'}
                    </ShopActionLabel>
                    <ShopActionLink>Visit: {engagement.value}</ShopActionLink>
                  </ShopLink>
                  <ShopArrow>
                    <Icon name="arrow-right" />
                  </ShopArrow>
                </EngagementHighlight>
              )}
              {engagement.actionType === 1 && (
                <EngagementHighlight>
                  <CallIcon>
                    <Icon name="phone" />
                  </CallIcon>
                  <CallNumber>{engagement.value}</CallNumber>
                  <CallActionLabel
                    onClick={() => {
                      onRedirectAnalytics({
                        eventType: merchantDetailEvent.contact,
                        data: {
                          value: engagement.value,
                          itemName: title,
                          mallName,
                        },
                      })
                    }}
                    href={`tel:${engagement.value}`}
                  >
                    {engagement.actionLabel
                      ? engagement.actionLabel
                      : 'Reserve Now'}
                  </CallActionLabel>
                </EngagementHighlight>
              )}
            </>
          )}
          <StoreLinksContainer>
            {!!contactNumbers &&
              contactNumbers.map(contactNumber => (
                <StoreLink key={contactNumber.value}>
                  <IconContainer>
                    <Icon name="phone" />
                  </IconContainer>
                  <DescriptionItem>{contactNumber.value}</DescriptionItem>
                  <StyledLink href={`tel:${contactNumber.value}`}>
                    Call
                  </StyledLink>
                </StoreLink>
              ))}
            {!!websiteUrl && (
              <StoreLink>
                <IconContainer>
                  <Icon name="web-link" />
                </IconContainer>
                <DescriptionItem>{websiteUrl}</DescriptionItem>
                <StyledLink href={websiteUrl}>Visit</StyledLink>
              </StoreLink>
            )}
            {operationStatus === 'Open' && !!operatingHours && (
              <StoreLink type="column">
                <IconContainer>
                  <Icon name="clock" />
                </IconContainer>
                <StoreLinkDescription>
                  {operatingHours.map(time => (
                    <p>
                      {time.name} {time.value}
                    </p>
                  ))}
                </StoreLinkDescription>
              </StoreLink>
            )}
            {!!onlineOrderingUrl && (
              <StoreLink type="column">
                <IconContainer>
                  <Icon name="shop" />
                </IconContainer>
                <DescriptionItem>{onlineOrderingUrl}</DescriptionItem>
                <StyledLink
                  rel="noreferrer"
                  target="_blank"
                  href={onlineOrderingUrl}
                >
                  Order
                </StyledLink>
              </StoreLink>
            )}
            {operationStatus === 'Closed' && (
              <StoreLink type="column">
                <IconContainer>
                  <Icon name="clock" />
                </IconContainer>
                <StoreLinkDescription>Closed</StoreLinkDescription>
              </StoreLink>
            )}
            {operationStatus === 'Temporarily Closed' && (
              <StoreLink type="column">
                <IconContainer>
                  <Icon name="clock" />
                </IconContainer>
                <StoreLinkDescription>Temporarily Closed</StoreLinkDescription>
              </StoreLink>
            )}

            {!!socialMediaLinks &&
              socialMediaLinks.map(link => {
                return !!link.value ? (
                  <StoreLink key={link.value}>
                    <IconContainer>
                      <Icon name="social-media" />
                    </IconContainer>
                    <DescriptionItem>{link.value}</DescriptionItem>

                    <StyledLink
                      href={link.value}
                      onClick={() =>
                        onRedirectAnalytics({
                          eventType: merchantDetailEvent.socialMedia,
                          data: {
                            value: link.value,
                            itemName: title,
                            mallName,
                          },
                        })
                      }
                    >
                      Visit
                    </StyledLink>
                  </StoreLink>
                ) : null
              })}
            {!!location && (
              <StoreLink>
                <IconContainer>
                  <Icon name="location" />
                </IconContainer>
                <DescriptionItem>
                  {floor && `${floor}, `}
                  {mallName && `${mallName}, `}
                  {location && `${location}`}
                </DescriptionItem>
                {/* <StyledLink
                  target="_blank"
                  href={`https://www.google.com/maps?q=${location}`}
                >
                  Visit
                </StyledLink> */}
              </StoreLink>
            )}
          </StoreLinksContainer>
          <ResponsiveAdsContainer
            sideModal
            desktop={<DesktopLeaderboard id="div-ad-innity-91043/18" />}
            mobile={<MobileRectangle id="div-ad-innity-91046/18" />}
          />
          {/* {adType ? (
            <ResponsiveAdsContainer
              sideModal
              desktop={<DesktopLeaderboard id="div-ad-innity-91043/18" />}
              mobile={<MobileRectangle id="div-ad-innity-91046/18" />}
            />
          ) : (
            <ResponsiveAdsContainer
              sideModal
              desktop={<InnerPageLeaderboard id="div-totalmedia-18a" />}
              mobile={<InnerPageRectangle id="div-totalmedia-18b" />}
            />
          )} */}
        </ContentContainer>
        {!!relatedArticles.length && (
          <RelatedContainer>
            <RelatedTitle>You Might Also Like:</RelatedTitle>
            {relatedArticles.map(item => (
              <ArticleCard
                key={`${item.type}-${item.itemId}`}
                title={item.title}
                imageUrl={item.bannerUrl}
                logoUrl={item.imageUrl}
                schedule={item.schedule || item.subtitle}
                // link={`${viewTypeBaseUrl(item.type)}/${
                //   item.type === 0 || item.type === 1
                //     ? item.slugName
                //     : item.itemId
                // }`}
                link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
              />
            ))}
          </RelatedContainer>
        )}
        <ExternalRedirectModal
          isEngagement={true}
          show={displayExternalRedirectModal}
          to={engagement && engagement.value}
          onClose={() => setDisplayExternalRedirectModal(false)}
          onProceed={() => setDisplayExternalRedirectModal(false)}
          zIndex={10025}
        />
        <FeatureMaintenanceModal
          show={showMaintenanceModal}
          onConfirmClick={toggleMaintenanceModal}
        />
      </Container>
    </SideModal>
  )
}

export default StoreModal
